//http://jsfiddle.net/99ycK/1/
import React from 'react';
import { Constants } from 'utilities/constants';
import dot1pt5red from "assets/images/rex/1pt5red.png";
import dot1pt5orange from "assets/images/rex/1pt5orange.png";
import dot1pt5yellow from "assets/images/rex/1pt5yellow.png";
import dot1pt5lightGreen from "assets/images/rex/1pt5lightGreen.png";
import dot1pt5green from "assets/images/rex/1pt5green.png";
import dot1pt5lightBlue from "assets/images/rex/1pt5lightBlue.png";
import dot1pt5blue from "assets/images/rex/1pt5blue.png";
import dot1pt5purple from "assets/images/rex/1pt5purple.png";
import dot1pt5gray from "assets/images/rex/1pt5gray.png";

export const getPinColorIcon = (colorId) => {
  switch (colorId) {
    case Constants.ViewsPropertyDataPinColor.RED:
      return dot1pt5red;
    case Constants.ViewsPropertyDataPinColor.ORANGE:
      return dot1pt5orange;
    case Constants.ViewsPropertyDataPinColor.YELLOW:
      return dot1pt5yellow;
    case Constants.ViewsPropertyDataPinColor.LIGHTGREEN:
      return dot1pt5lightGreen;
    case Constants.ViewsPropertyDataPinColor.GREEN:
      return dot1pt5green;
    case Constants.ViewsPropertyDataPinColor.LIGHTBLUE:
      return dot1pt5lightBlue;
    case Constants.ViewsPropertyDataPinColor.BLUE:
      return dot1pt5blue;
    case Constants.ViewsPropertyDataPinColor.PURPLE:
      return dot1pt5purple;
    case Constants.ViewsPropertyDataPinColor.GRAY:
      return dot1pt5gray;
    default:
      return dot1pt5green;
  }
}

export const getPinColorValue = (colorId) => {
  switch (colorId) {
    case Constants.ViewsPropertyDataPinColor.RED:
      return '#dd3730';
    case Constants.ViewsPropertyDataPinColor.ORANGE:
      return '#e58c00';
    case Constants.ViewsPropertyDataPinColor.YELLOW:
      return '#f3ec19';
    case Constants.ViewsPropertyDataPinColor.LIGHTGREEN:
      return '#a8f584';
    case Constants.ViewsPropertyDataPinColor.GREEN:
      return '#308085';
    case Constants.ViewsPropertyDataPinColor.LIGHTBLUE:
      return '#62bbee';
    case Constants.ViewsPropertyDataPinColor.BLUE:
      return '#004990';
    case Constants.ViewsPropertyDataPinColor.PURPLE:
      return '#b432ff';
    case Constants.ViewsPropertyDataPinColor.GRAY:
      return '#afafaf';
    default:
      return '#308085';
  }
}

export const colorPalettePresets = [{
  id: 'shapeDefault',
  c0: "#dd514c",
  c1: "#fdc980",
  c2: "#5eb95e",
  opacity: 'bb'
}, {
  id: 'yellowToBlue',
  c0: "#ecec37",
  c1: "#90e0dd",
  c2: "#5986d6",
  opacity: 'dd'
}, {
  id: 'whiteToBlue',
  c0: "#e0efff",
  c1: "#71c0fd",
  c2: "#0a93ff",
  opacity: 'dd'
}, {
  id: 'blueToPurple',
  c0: "#00c4df",
  c1: "#0024dd",
  c2: "#d600df",
  opacity: '80'
}, {
  id: 'whiteToOrange',
  c0: "#ffe7c9",
  c1: "#ffc57c",
  c2: "#ffa129",
  opacity: 'dd'
}, {
  id: 'blueToGreen',
  c0: "#68a4ff",
  c1: "#5dce9c",
  c2: "#2bac31",
  opacity: 'bb'
}
, {
  id: 'gray',
  c0: "#666666",
  c1: "#666666",
  c2: "#666666",
  opacity: '1a'
}]

export const ColorPaletteDisplay = ({ palette, fullWidth, height }) => {
    return (
        <div style={{
            // marginLeft: 10,
            borderRadius: 3,                                        
            width: fullWidth ? '100%' : 70, 
            height: height ?? 20,
            display: 'flex', 
            overflow: 'hidden',
        }}>
            <div style={{
                width: '50%',
                background: `linear-gradient(to right, ${palette?.c0}, ${palette?.c1})`
                }}></div>
            <div style={{
                width: '50%',
                background: `linear-gradient(to right, ${palette?.c1}, ${palette?.c2})`, right: 0
                }}></div>
        </div>
    )
}

var Color = function(hexOrObject) {
    var obj;
    if (hexOrObject instanceof Object) {
        obj = hexOrObject;
    } else {
        obj = LinearColorInterpolator.convertHexToRgb(hexOrObject);
    }
    this.r = obj.r;
    this.g = obj.g;
    this.b = obj.b;
    this.a = obj.a;
}
Color.prototype.asRgbCss = function() {
    return `rgba(${this.r}, ${this.g}, ${this.b}${this.a != null ? `, ${this.a}` : ''})`;
}
 
var LinearColorInterpolator = {
    // convert 6-digit hex to rgb components;
    // accepts with or without hash ("335577" or "#335577")
    convertHexToRgb: function(hex) {
        var match = hex.replace(/#/,'').match(/.{1,2}/g);
        return new Color({
            r: parseInt(match[0], 16),
            g: parseInt(match[1], 16),
            b: parseInt(match[2], 16),
            a: match[3] != null ? parseInt(match[3], 16)/256 : null
        });
    },
    // left and right are colors that you're aiming to find
    // a color between. Percentage (0-100) indicates the ratio
    // of right to left. Higher percentage means more right,
    // lower means more left.
    findColorBetween: function(left, right, percentage) {
        var newColor = {};
        var components = ["r", "g", "b", "a"];
        for (var i = 0; i < components.length; i++) {
            var c = components[i];
            if (left[c] == null || right[c] == null) continue;
            // newColor[c] = Math.round(left[c] + (right[c] - left[c]) * percentage / 100);
            const value = left[c] + (right[c] - left[c]) * percentage / 100;
            newColor[c] = c === 'a' ? value : Math.round(value);
        }
        return new Color(newColor);
    }
}

function getColorsForPalette(palette = { c0: '#dd514c', c1: '#faa732', c2: '#5eb95e' }) {
    return {
        c0: new Color(palette.c0),
        c1: new Color(palette.c1),
        c2: new Color(palette.c2)
    }
}

export function calculateColor(palette, min, max, mid, value) {
    const { c0, c1, c2 } = getColorsForPalette(palette);
    const hasSingleValue = min === max;

    const valuePct = hasSingleValue ? 100 : (1 - ((max - value)/(max-min)))*100;

    var left, right, percentage;
    if (!hasSingleValue && value < mid) {
        left = c0;
        right = c1;
        percentage = valuePct*2;
    } else {
        left = c1;
        right = c2;
        percentage = (valuePct - 50)*2;
    }

    return LinearColorInterpolator.findColorBetween( left, right, percentage ).asRgbCss();
}